import { c as _c } from "react/compiler-runtime";
// Выбор картинок задания: фото к позиции, логотип и обложка магазина.
// Картинки — из материалов (в том числе распакованные из архивов), с путём
// папки: по нему человек и находит «Платья/Ривьера/2.jpg».
import { Check } from "lucide-react";
import { useState } from "react";
import type { CatalogImportFile } from "@osmix/contracts";
import { Button } from "@osmix/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@osmix/ui/dialog";
import { Input } from "@osmix/ui/input";
import { cn } from "@/lib/utils";
import { ImportThumb } from "./shared";
const PAGE = 60;
export function ImagePicker(t0) {
  const $ = _c(76);
  const {
    open,
    jobId,
    files,
    title,
    description,
    multiple: t1,
    exclude: t2,
    confirmLabel: t3,
    onConfirm,
    onClose
  } = t0;
  const multiple = t1 === undefined ? true : t1;
  let t4;
  if ($[0] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const exclude = t4;
  const confirmLabel = t3 === undefined ? "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" : t3;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const [picked, setPicked] = useState(t5);
  const [query, setQuery] = useState("");
  const [limit, setLimit] = useState(PAGE);
  let t6;
  if ($[3] !== exclude) {
    t6 = new Set(exclude);
    $[3] = exclude;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const taken = t6;
  let T0;
  let T1;
  let close;
  let shown;
  let t10;
  let t11;
  let t12;
  let t13;
  let t7;
  let t8;
  let t9;
  if ($[5] !== description || $[6] !== files || $[7] !== jobId || $[8] !== limit || $[9] !== multiple || $[10] !== onClose || $[11] !== open || $[12] !== picked || $[13] !== query || $[14] !== taken || $[15] !== title) {
    const images = files.filter(_temp);
    const q = query.trim().toLowerCase();
    shown = q ? images.filter(f_0 => `${f_0.path} ${f_0.filename}`.toLowerCase().includes(q)) : images;
    let t14;
    if ($[27] !== multiple || $[28] !== taken) {
      t14 = id => {
        if (taken.has(id)) {
          return;
        }
        if (!multiple) {
          setPicked([id]);
          return;
        }
        setPicked(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
      };
      $[27] = multiple;
      $[28] = taken;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    const toggle = t14;
    let t15;
    if ($[30] !== onClose) {
      t15 = () => {
        setPicked([]);
        setQuery("");
        setLimit(PAGE);
        onClose();
      };
      $[30] = onClose;
      $[31] = t15;
    } else {
      t15 = $[31];
    }
    close = t15;
    T1 = Dialog;
    t12 = open;
    if ($[32] !== close) {
      t13 = next => !next && close();
      $[32] = close;
      $[33] = t13;
    } else {
      t13 = $[33];
    }
    T0 = DialogContent;
    t9 = "flex max-h-[90dvh] flex-col gap-3 sm:max-w-3xl";
    let t16;
    if ($[34] !== title) {
      t16 = <DialogTitle>{title}</DialogTitle>;
      $[34] = title;
      $[35] = t16;
    } else {
      t16 = $[35];
    }
    let t17;
    if ($[36] !== description) {
      t17 = description && <DialogDescription>{description}</DialogDescription>;
      $[36] = description;
      $[37] = t17;
    } else {
      t17 = $[37];
    }
    if ($[38] !== t16 || $[39] !== t17) {
      t10 = <DialogHeader className="pr-8">{t16}{t17}</DialogHeader>;
      $[38] = t16;
      $[39] = t17;
      $[40] = t10;
    } else {
      t10 = $[40];
    }
    let t18;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = e => setQuery(e.target.value);
      $[41] = t18;
    } else {
      t18 = $[41];
    }
    if ($[42] !== query) {
      t11 = <Input value={query} onChange={t18} placeholder={"\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438 \u0444\u0430\u0439\u043B\u0430 \u0438\u043B\u0438 \u043F\u0430\u043F\u043A\u0435"} aria-label={"\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430\u043C"} className="h-9" />;
      $[42] = query;
      $[43] = t11;
    } else {
      t11 = $[43];
    }
    t7 = "min-h-0 flex-1 overflow-y-auto";
    t8 = shown.length === 0 ? <p className="py-10 text-center text-sm text-muted-foreground">{images.length === 0 ? "\u0412 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430\u0445 \u0437\u0430\u0434\u0430\u043D\u0438\u044F \u043D\u0435\u0442 \u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A." : "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0448\u043B\u043E\u0441\u044C."}</p> : <div className="grid grid-cols-3 gap-2 sm:grid-cols-5">{shown.slice(0, limit).map(file => {
        const selected = picked.includes(file.id);
        const already = taken.has(file.id);
        return <button key={file.id} type="button" onClick={() => toggle(file.id)} disabled={already} aria-pressed={selected} title={file.path || file.filename} className={cn("group relative flex flex-col gap-1 rounded-md border p-1 text-left transition-colors hover:bg-muted/60 disabled:opacity-50", selected && "border-primary ring-2 ring-primary/40")}><ImportThumb jobId={jobId} fileId={file.id} className="aspect-[4/5] size-auto w-full" /><span className="truncate text-[11px] text-muted-foreground">{file.path || file.filename}</span>{(selected || already) && <span className="absolute top-2 right-2 grid size-5 place-items-center rounded-full bg-primary text-primary-foreground"><Check className="size-3" /></span>}</button>;
      })}</div>;
    $[5] = description;
    $[6] = files;
    $[7] = jobId;
    $[8] = limit;
    $[9] = multiple;
    $[10] = onClose;
    $[11] = open;
    $[12] = picked;
    $[13] = query;
    $[14] = taken;
    $[15] = title;
    $[16] = T0;
    $[17] = T1;
    $[18] = close;
    $[19] = shown;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    T0 = $[16];
    T1 = $[17];
    close = $[18];
    shown = $[19];
    t10 = $[20];
    t11 = $[21];
    t12 = $[22];
    t13 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t14;
  if ($[44] !== limit || $[45] !== shown.length) {
    t14 = shown.length > limit && <div className="mt-3 flex justify-center"><Button variant="outline" size="sm" onClick={() => setLimit(_temp2)}>Показать ещё {Math.min(PAGE, shown.length - limit)}</Button></div>;
    $[44] = limit;
    $[45] = shown.length;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== t14 || $[48] !== t7 || $[49] !== t8) {
    t15 = <div className={t7}>{t8}{t14}</div>;
    $[47] = t14;
    $[48] = t7;
    $[49] = t8;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== close) {
    t16 = <Button variant="outline" onClick={close}>Отмена</Button>;
    $[51] = close;
    $[52] = t16;
  } else {
    t16 = $[52];
  }
  const t17 = picked.length === 0;
  let t18;
  if ($[53] !== close || $[54] !== onConfirm || $[55] !== picked) {
    t18 = () => {
      onConfirm(picked);
      close();
    };
    $[53] = close;
    $[54] = onConfirm;
    $[55] = picked;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  const t19 = multiple && picked.length > 0 ? `${confirmLabel} (${picked.length})` : confirmLabel;
  let t20;
  if ($[57] !== t17 || $[58] !== t18 || $[59] !== t19) {
    t20 = <Button disabled={t17} onClick={t18}>{t19}</Button>;
    $[57] = t17;
    $[58] = t18;
    $[59] = t19;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  let t21;
  if ($[61] !== t16 || $[62] !== t20) {
    t21 = <DialogFooter>{t16}{t20}</DialogFooter>;
    $[61] = t16;
    $[62] = t20;
    $[63] = t21;
  } else {
    t21 = $[63];
  }
  let t22;
  if ($[64] !== T0 || $[65] !== t10 || $[66] !== t11 || $[67] !== t15 || $[68] !== t21 || $[69] !== t9) {
    t22 = <T0 className={t9}>{t10}{t11}{t15}{t21}</T0>;
    $[64] = T0;
    $[65] = t10;
    $[66] = t11;
    $[67] = t15;
    $[68] = t21;
    $[69] = t9;
    $[70] = t22;
  } else {
    t22 = $[70];
  }
  let t23;
  if ($[71] !== T1 || $[72] !== t12 || $[73] !== t13 || $[74] !== t22) {
    t23 = <T1 open={t12} onOpenChange={t13}>{t22}</T1>;
    $[71] = T1;
    $[72] = t12;
    $[73] = t13;
    $[74] = t22;
    $[75] = t23;
  } else {
    t23 = $[75];
  }
  return t23;
}
function _temp2(n) {
  return n + PAGE;
}
function _temp(f) {
  return f.isImage && f.status !== "failed";
}